import React from 'react';
import { ATTRIBUTE_ICONS } from '../utils/constants';
import type { CardAttribute } from '../types';

// ========================================
// 属性アイコンコンポーネント
// ========================================

interface AttributeIconProps {
  attribute: CardAttribute;
  size?: number;        // px単位、デフォルト24
  className?: string;
  style?: React.CSSProperties;
}

const AttributeIcon: React.FC<AttributeIconProps> = ({
  attribute,
  size = 24,
  className,
  style,
}) => {
  const iconPath = ATTRIBUTE_ICONS[attribute] || ATTRIBUTE_ICONS['なし'];

  return (
    <img
      src={iconPath}
      alt={`${attribute}属性`}
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))',
        ...style,
      }}
      draggable={false}
    />
  );
};

export default AttributeIcon;
